// role constants
export const ROLES = {
  OWNER: "OWNER", // Eigentümer
  TENANT: "TENANT", // Mieter
  COUNSELOR: "COUNSELOR", // Beirat
  STAFF: "STAFF", // Hauswart
  CONTRACTOR: "CONTRACTOR", // Dienstleister
  EXTERNAL_CONTACT: "EXTERNAL_CONTACT", // Extern
  TICKET_MANAGER: "TICKET_MANAGER", // TManager
  // ---------------
  PROPERTY_MANAGER: "PROPERTY_MANAGER", // Immobilienverwalter
  ADMIN: "ADMIN", // Administrator
} as const;

export type Role = (typeof ROLES)[keyof typeof ROLES];
